import React, { memo } from "react";

const Tooltip = memo((props) => {
  return (
    <span className="group relative">
      <span className="w-72 h-72 pointer-events-none absolute -top-10 left-1/2 -translate-x-1/2 rounded bg-white px-2 py-1 text-black opacity-0 transition before:absolute before:left-1/2 before:top-full before:-translate-x-1/2 before:border-4 before:border-transparent before:border-t-black before:content-[''] group-hover:opacity-100">
        Don't wanna wait for more than a week to get started? Pay to be among
        the first to enter a contest! {/* {props.text} */}
      </span>

      {props.children}
    </span>
  );
});

Tooltip.displayName = "Tooltip";

export default Tooltip;
